var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildStream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "40px",
    viewBox: "0 0 32 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CF6BC66C-326E-4630-9EBD-347862C1E793") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup",
    transform: "translate(-404.000000, -360.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Build-Stream",
    transform: "translate(171.500000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Build-Stream-Icon",
    transform: "translate(25.500000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7333333,13.2760784 C26.7333333,13.3760784 26.6517647,13.4576471 26.5513725,13.4576471 L20.2603922,13.4576471 L20.2603922,13.4509804 L8.57529412,13.4509804 L8.57529412,13.4576471 L3.31882353,13.4576471 C3.21882353,13.4576471 3.1372549,13.3760784 3.1372549,13.2760784 L3.1372549,9.18470588 C3.1372549,9.06705882 3.41647059,8.62039216 4.10705882,8.21647059 C5.80196078,7.2254902 7.2227451,5.80509804 8.21686275,4.10666667 C8.62039216,3.41607843 9.06666667,3.1372549 9.18470588,3.1372549 L26.5513725,3.1372549 C26.6517647,3.1372549 26.7333333,3.21882353 26.7333333,3.31882353 L26.7333333,13.2760784 Z M16.7760784,36.6815686 C16.7760784,36.7811765 16.694902,36.8627451 16.5945098,36.8627451 L13.2756863,36.8627451 C13.1756863,36.8627451 13.0941176,36.7811765 13.0941176,36.6815686 L13.0941176,16.594902 C13.0941176,16.592549 13.0937255,16.5905882 13.0937255,16.5882353 L16.7764706,16.5882353 C16.7764706,16.5905882 16.7760784,16.592549 16.7760784,16.594902 L16.7760784,36.6815686 Z M26.5513725,0 L9.18470588,0 C7.60627451,0 6.30509804,1.16078431 5.50823529,2.52352941 C4.78627451,3.75686275 3.75647059,4.78745098 2.52352941,5.50823529 C1.16039216,6.3054902 -3.55271368e-15,7.60666667 -3.55271368e-15,9.18470588 L-3.55271368e-15,13.2760784 C-3.55271368e-15,15.1090196 1.48627451,16.594902 3.31882353,16.594902 L9.95686275,16.594902 L9.95686275,36.6815686 C9.95686275,38.5141176 11.4427451,40 13.2756863,40 L16.5945098,40 C18.427451,40 19.9133333,38.5141176 19.9133333,36.6815686 L19.9133333,16.594902 L26.5513725,16.594902 C28.3843137,16.594902 29.8705882,15.1090196 29.8705882,13.2760784 L29.8705882,3.31882353 C29.8705882,1.48627451 28.3843137,0 26.5513725,0 L26.5513725,0 Z",
    id: "Fill-1-Copy"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildStream);
export default __webpack_public_path__ + "static/media/build-stream.8af26f13.svg";
export { ForwardRef as ReactComponent };